import { CORE_AXIOS, type Http } from '@/core'
import { container } from 'tsyringe'

export const fetchDssOrderList = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/dss/order`, data)
}

export const refundWalletPay = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/dss/walletPay/refund`, data)
}
export const refundWxpay = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/dss/wxpay/refund`, data)
}
export const refundWxpayQuery = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/dss/wxpay/refund/query`, data)
}
export const refundAlipay = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/dss/alipay/refund`, data)
}
export const refundAlipayQuery = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/dss/alipay/refund/query`, data)
}
